import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoCertificadoStorage } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoCertificadoStorageService extends BaseResourceService<FavorecidoCertificadoStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-certificado-storages`, injector);
  }

  public upload(arquivo: any, orgao: number, favorecido: number, item: FavorecidoCertificadoStorage, descricao?: string): Observable<FavorecidoCertificadoStorage[]> {
    const formData = new FormData();
    formData.append('files', arquivo);
    formData.append('referencia_documento', item.referencia_documento ?? '');

    if (item.data_vencimento) {
      formData.append('data_vencimento', this.formatarData(item.data_vencimento));
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<FavorecidoCertificadoStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${favorecido}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  private formatarData(data: Date | string): string {
    const valor = data instanceof Date ? data : new Date(data);
    const ano = valor.getFullYear();
    const mes = `${valor.getMonth() + 1}`.padStart(2, '0');
    const dia = `${valor.getDate()}`.padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  }
}
